var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTesla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E82127",
    fillRule: "evenodd",
    d: "M34.854 9.914c-5.15-2.271-10.18-2.993-14.576-2.96-4.396-.033-9.427.689-14.577 2.96-.613-1.125-.864-1.808-.864-1.808 5.629-2.254 10.9-3.025 15.44-3.044 4.54.019 9.813.79 15.443 3.044 0 0-.177.554-.866 1.808zM24.6 11.591L20.28 36.18l-4.356-24.592c-4.09.003-5.387.46-5.576 2.325 0 0-2.764-1.042-4.156-3.16 5.437-2.549 10.9-2.664 10.9-2.664l3.184 3.925L23.46 8.09s5.464.115 10.901 2.664c-1.393 2.117-4.156 3.16-4.156 3.16-.188-1.866-1.486-2.323-5.605-2.323z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTesla);
export default __webpack_public_path__ + "static/media/logo-tesla.214feb0f.svg";
export { ForwardRef as ReactComponent };